<script setup>
import { ref, watch } from 'vue';

const props = defineProps({
	items: {
		type: [Array, null],
		required: true,
		validator(value, props) {
			let requiredKeys = ['name', 'value', 'count', 'key'];

			return value.every((item) => requiredKeys.every((key) => key in item));
		}
	}
});

const emit = defineEmits(['facet-clicked']);

const activeItem = ref(null);

watch(
	() => props.items,
	(newValue, oldValue) => {
		activeItem.value = newValue[0].name;
	},
	{
		once: true
	}
);

function getText(item) {
	if (!item.count) return item.name;

	return `${item.name} (${item.count})`;
}

function getClasses(item) {
	return [
		'search-facet-list__list-btn',
		item.name == activeItem.value ? 'search-facet-list__list-btn--active' : null
	];
}

function onClick(item) {
	activeItem.value = item.value;

	emit('facet-clicked', item);
}
</script>

<template>
	<div class="search-facet-list" v-if="items">
		<nav class="search-facet-list__nav" aria-labelledby="list__title">
			<div class="search-facet-list__header">
				<h2 id="search-facet-list__title" class="search-facet-list__title">
					Search Facets
				</h2>
			</div>

			<ul class="search-facet-list__list">
				<li class="search-facet-list__list-item" v-for="item in items" :key="item.key">
					<button
						type="button"
						:class="getClasses(item)"
						@click="onClick(item)"
						v-text="getText(item)"
					></button>
				</li>
			</ul>
		</nav>
	</div>
</template>
